import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withAccount } from '../../../../../components/AccountContext';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import { activateSuperLinkImport } from '../../../../../services/apps/RespondentServices';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { matchShape, growlShape, historyShape } from '../../../../../components/prop-types';
import ImportFileDetailGeneric from './ImportFileDetailGeneric';
import DefinitionListContainer from './DefinitionListContainer';
import ImportConfirmModal from './ImportConfirmModal';


class ImportFileDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isActiveModal: false,
      isCancel: true,
    };
    this.rejectActive = this.rejectActive.bind(this);
    this.acceptActive = this.acceptActive.bind(this);
    this.openActiveModal = this.openActiveModal.bind(this);
  }

  async acceptActive() {
    const {
      match, growl, currentAccount, history,
    } = this.props;
    const { isOverwrite } = this.state;

    const { superLinkId, importFileId: importId } = match.params;
    const input = {
      accountId: currentAccount,
      importId,
      superLinkId,
      overwrite: isOverwrite,
    };
    this.setState({ isActiveModal: false, isLoading: true });
    try {
      await activateSuperLinkImport(input);
      const redirectUrl = `/accounts/${currentAccount}/super-links/${superLinkId}/import/${importId}`;
      history.push(redirectUrl);
    } catch (errors) {
      growlErrors(growl, errors);
    }
    this.setState({ isLoading: false });
  }

  rejectActive() {
    this.setState({ isActiveModal: false });
  }

  openActiveModal() {
    this.setState({
      isActiveModal: true,
      isCancel: true,
      isOverwrite: false,
    });
  }

  render() {
    const { data } = this.props;
    const {
      isActiveModal, isCancel, isLoading,
    } = this.state;

    const {
      status, messages,
    } = data.respondentImport;
    return (
      <div className="p-grid">
        <div className="p-col">
          <div className="brand-detailed-wrapper">
            {status === 'FAILED_IMPORT' && (
              <div className="panel panel-default panel-padded mt25">
                <div className="panel-heading">
                  <FormattedMessage
                    id="file_import.actions.showLog"
                    defaultMessage="Show Log"
                  />
                </div>
                <div className="panel-body">
                  {messages.map((message, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index}>
                      <span>{`${index + 1}. ${message}`}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {status === 'VALID_IMPORT' && (
              <div>
                <hr />
                <h2 className="section-title">
                  <FormattedMessage
                    id="file_import.definition"
                    defaultMessage="Definitions"
                  />
                </h2>
                <ImportFileDetailGeneric
                  respondentImport={data.respondentImport}
                  isLoading={isLoading}
                  openActiveModal={this.openActiveModal}
                />
                <DefinitionListContainer />
              </div>
            )}
            {status === 'ACTIVATED' && (
              <div>
                <hr />
                <h2 className="section-title">
                  <FormattedMessage
                    id="file_import.definition"
                    defaultMessage="Definitions"
                  />
                </h2>
                <ImportFileDetailGeneric
                  respondentImport={data.respondentImport}
                  isLoading={isLoading}
                  openActiveModal={this.openActiveModal}
                />
              </div>
            )}
          </div>
          <ImportConfirmModal
            modalOpen={isActiveModal}
            reject={this.rejectActive}
            confirm={this.acceptActive}
            isCancel={isCancel}
          />
        </div>
      </div>
    );
  }
}

ImportFileDetail.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  history: historyShape.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { translatedTags } = state.i18n;
  return {
    ...ownProps,
    translatedTags,
  };
};

export default withRouter(
  withGrowl(
    connect(
      mapStateToProps,
    )(withAccount(ImportFileDetail)),
  ),
);
